/**
 * NeoShell — shell shadcn del NeoCore (ADR 014, F1). Reemplaza AppShell.
 * Sidebar + header (título, reloj GT, toggle de tema) + contenido (Outlet) +
 * footer legal. Neo dark por defecto. Conserva GlobalAlertBanner y el chime de
 * eventos del core. Las pantallas de contenido migran una a una (F2+).
 */
import { useEffect, useState } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import {
  SidebarInset, SidebarProvider, SidebarTrigger,
} from '@/components/ui/sidebar'
import { Separator } from '@/components/ui/separator'
import { AppSidebar } from './app-sidebar'
import { ThemeToggle } from '@/components/theme-toggle'
import { GlobalAlertBanner } from '@/components/GlobalAlertBanner'
import { useCoreEventAlerts } from '@/lib/hooks/useCoreEventAlerts'
import { LEGAL_VERSION } from '@/lib/legal/content'
import { TITLE_BY_PATH } from './nav-data'

function useClock() {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30_000); return () => clearInterval(t) }, [])
  return now
}

export function NeoShell() {
  const loc = useLocation()
  useCoreEventAlerts()
  const now = useClock()
  const title = TITLE_BY_PATH[loc.pathname] ?? 'NeoCore'
  const hoy = now.toLocaleDateString('es-GT', { weekday: 'long', day: '2-digit', month: 'short', timeZone: 'America/Guatemala' })
  const hora = now.toLocaleTimeString('es-GT', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Guatemala' })

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="font-sans">
        <header className="flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4 text-foreground">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-1 h-4" />
          <h1 className="text-sm font-medium">{title}</h1>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-xs text-muted-foreground capitalize sm:inline">{hoy} · {hora}</span>
            <ThemeToggle />
          </div>
        </header>
        <GlobalAlertBanner />
        {/* Contenido en claro durante la transición: las páginas viejas usan sus
            propios tokens light y quedan legibles. Migran a dark una a una (F2+). */}
        <main className="flex-1 p-4 md:p-6" style={{ background: 'var(--bg, #f7f7f7)', color: 'var(--n-900, #14171c)' }}>
          <Outlet />
        </main>
        <footer className="flex items-center justify-center gap-2 px-6 py-6 text-[11px] text-muted-foreground">
          <Link to="/legal/terminos" className="hover:text-foreground">Términos</Link>
          <span className="opacity-50">·</span>
          <Link to="/legal/privacidad" className="hover:text-foreground">Privacidad</Link>
          <span className="opacity-50">·</span>
          <span>v{LEGAL_VERSION}</span>
        </footer>
      </SidebarInset>
    </SidebarProvider>
  )
}
